
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronRight, Users, Calendar, MessageSquare } from 'lucide-react';

const FeaturesSection: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">Key Features</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Players Lockeroom brings together everything you need to manage, play, and enjoy sports in one place.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="p-6 border border-gray-700 rounded-lg bg-gray-900">
            <div className="w-12 h-12 rounded-full bg-sports-green/20 flex items-center justify-center mb-4">
              <Users className="h-6 w-6 text-sports-green" />
            </div>
            <h3 className="text-xl font-semibold mb-2 text-white">Team Management</h3>
            <p className="text-gray-300">
              Create and manage teams, rosters, and positions. Assign roles to players and staff.
            </p>
          </div>
          
          <div className="p-6 border border-gray-700 rounded-lg bg-gray-900">
            <div className="w-12 h-12 rounded-full bg-sports-green/20 flex items-center justify-center mb-4">
              <Calendar className="h-6 w-6 text-sports-green" />
            </div>
            <h3 className="text-xl font-semibold mb-2 text-white">Scheduling</h3>
            <p className="text-gray-300">
              Organize practices, games, and events. Send reminders and get notified of changes.
            </p>
          </div>
          
          <div className="p-6 border border-gray-700 rounded-lg bg-gray-900">
            <div className="w-12 h-12 rounded-full bg-sports-green/20 flex items-center justify-center mb-4">
              <MessageSquare className="h-6 w-6 text-sports-green" />
            </div>
            <h3 className="text-xl font-semibold mb-2 text-white">Communication</h3>
            <p className="text-gray-300">
              Team messaging, direct messages, and announcements to keep everyone connected.
            </p>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <Button asChild variant="outline" className="group border-gray-600 text-white hover:bg-gray-800">
            <Link to="/register">
              Get Started <ChevronRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
